import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import lazyLoad from '@helper/lazy-load'

const router = [
    {
        path: '/app/robot',
        element: lazyLoad(() => import('@pages/robot/components/main')),
        loader: () => ({ menuIndex: 5, key: 'robot.robot', icon: 'icon-jiqiren', show: true }),
        children: [
            {
                index: true,
                element: <Navigate to="/app/robot/qa" />
            },
            {
                path: '/app/robot/qa',
                element: <Outlet />,
                loader:() => ({
                    menuIndex: 1,
                    key: 'robot.qa.qa',
                    show: true
                }),
                children: [
                    {
                        index: true,
                        element: <Navigate to="/app/robot/qa/basic" />
                    },
                    {
                        path: '/app/robot/qa/basic',
                        element: lazyLoad(() => import('@pages/robot-qa-basic/components/main')),
                        loader:()=>({
                            menuIndex: 1,
                            key: 'robot.qa.basic',
                            activeMenu: '/app/robot/qa/basic',
                            show: true
                        })
                    },
                    {
                        path: '/app/robot/qa/goods',
                        element: <Outlet />,
                        loader:()=>({
                            menuIndex: 2,
                            key: 'robot.qa.goods',
                            activeMenu: '/app/robot/qa/goods',
                            show: true
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate to="/app/robot/qa/goods/list" />
                            },
                            {
                                path: '/app/robot/qa/goods/list',
                                element: lazyLoad(() => import('@pages/robot-goods/components/main')),
                                loader:()=>({
                                    key: 'robot.qa.goods',
                                    activeMenu: '/app/robot/qa/goods'
                                })
                            },
                            {
                                path: '/app/robot/qa/goods/list/:linkId',
                                element: lazyLoad(() => import('@pages/robot-goods-detail/components/main')),
                                loader:()=>({
                                    key: 'robot.qa.goodsDetail',
                                    activeMenu: '/app/robot/qa/goods',
                                    show: true
                                })
                            }
                        ]
                    },
                    {
                        path: '/app/robot/qa/size',
                        element: lazyLoad(() => import('@pages/robot-qa-size/components/main')),
                        loader:()=>({
                            menuIndex: 3,
                            key: 'robot.qa.size',
                            activeMenu: '/app/robot/qa/size',
                            show: true
                        })
                    },
                    {
                        path: '/app/robot/qa/high-frequency',
                        element: <Outlet />,
                        loader:()=>({
                            menuIndex: 4,
                            key: 'robot.qa.highFrequency',
                            activeMenu: '/app/robot/qa/high-frequency',
                            show: true
                        }),
                        children: [
                            {
                                index: true,
                                element: <Navigate to="/app/robot/qa/high-frequency/list" />
                            },
                            {
                                path: '/app/robot/qa/high-frequency/list',
                                element: lazyLoad(() => import('@pages/robot-qa-high-frequency/components/main')),
                                loader:()=>({
                                    key: 'robot.qa.highFrequency',
                                    activeMenu: '/app/robot/qa/high-frequency'
                                })
                            },
                            {
                                path: '/app/robot/qa/high-frequency/list/:categoryId',
                                element: lazyLoad(() => import('@pages/robot-qa-high-frequency-detail/components/main')),
                                loader:()=>({
                                    key: 'robot.qa.highFrequencyDetail',
                                    activeMenu: '/app/robot/qa/high-frequency',
                                    show: true
                                })
                            }
                        ]
                    },
                ]
            },
            {
                path: '/app/robot/qdata',
                element: lazyLoad(() => import('@pages/robot-qdata/components/main')),
                loader:() => ({
                    menuIndex: 2,
                    key: 'robot.qdata',
                    activeMenu: '/app/robot/qdata',
                    show: true
                })
            },
            {
                path: '/app/robot/dataOverview',
                element: lazyLoad(() => import('@pages/robot-qdata/components/main')),
                loader:() => ({
                    menuIndex: 3,
                    key: 'robot.dataOverview',
                    activeMenu: '/app/robot/dataOverview',
                    show: true
                })
            },
            {
                path: '/app/robot/speech',
                element: lazyLoad(() => import('@pages/robot-speech/components/main')),
                loader:() => ({
                    menuIndex: 4,
                    key: 'robot.speech',
                    activeMenu: '/app/robot/speech',
                    show: true
                })
            },
            {
                path: '/app/robot/interactive',
                element: lazyLoad(() => import('@pages/robot-interactive/components/main')),
                loader:() => ({
                    menuIndex: 5,
                    key: 'robot.interactive',
                    activeMenu: '/app/robot/interactive',
                    show: true
                })
            },
            {
                path: '/app/robot/lcheck',
                element: <Outlet />,
                loader:() => ({
                    menuIndex: 6,
                    key: 'robot.lcheck',
                    activeMenu: '/app/robot/lcheck',
                    show: true
                }),
                children: [
                    {
                        index: true,
                        element: <Navigate to="/app/robot/lcheck/list" />
                    },
                    {
                        path: '/app/robot/lcheck/list',
                        element: lazyLoad(() => import('@pages/robot-lcheck/components/main')),
                        loader:() => ({
                            key: 'robot.lcheck',
                            activeMenu: '/app/robot/lcheck',
                        })
                    },
                    {
                        path: '/app/robot/lcheck/:sessionId',
                        element: lazyLoad(() => import('@pages/robot-lcheck-detail/components/main')),
                        loader:() => ({
                            key: 'robot.lcheckChatDetail',
                            activeMenu: '/app/robot/lcheck',
                            show: true
                        })
                    },
                ]
            },
        ]
    }
]

export default router
